function availOffersCopy(text, buttonEl) {
  const couponEl = buttonEl.parentElement.querySelector('.coupon-code');
  const originalText = couponEl.getAttribute('data-original');

  navigator.clipboard
    .writeText(text)
    .then(() => {
      couponEl.textContent = 'Copied!';
      setTimeout(() => {
        couponEl.textContent = originalText;
      }, 1500);
    })
    .catch(() => {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);

      couponEl.textContent = 'Copied!';
      setTimeout(() => {
        couponEl.textContent = originalText;
      }, 1500);
    });
}
